export default __webpack_public_path__ + "static/media/ethics-and-behavioral-sciences.67da492a.svg";